export default __webpack_public_path__ + "static/media/faith.a7f01108.webp";